// extracted by mini-css-extract-plugin
export default {"page-content__container":"Page_page-content__container__BQur+","dark":"Page_dark__DCkvU"};